import React, {useState, useEffect, useRef} from 'react';
import { useHistory } from 'react-router-dom';
import styled from 'styled-components';

import {isValidEmail, isValidPassword, isValidNickname,isValidName, removeItem} from 'utils/utils'
import server from 'server/serverController2';
import loadingImg from 'images/icon/yellow_loading-40x40.gif';


import CenterModal from 'components/presenters/modal/CenterModal';
import SignupEmailScene from 'components/presenters/signup/SignupEmailScene';
import SignupCompanyEmailScene from 'components/presenters/signup/SignupCompanyEmailScene';
import SignupPasswordScene from 'components/presenters/signup/SignupPasswordScene';
import SignupNicknameScene from 'components/presenters/signup/SignupNicknameScene';
import SignupNameScene from 'components/presenters/signup/SignupNameScene';
import ScenePaginationFooter from 'components/presenters/footer/ScenePaginationFooter';
import TitleHeader from 'components/presenters/header/TitleHeader';
import TermsAndConditionCheckModal from 'components/presenters/signup/TermsAndConditionCheckModal';
import TermsAndConditionModal from 'components/presenters/signup/TermsAndConditionModal';
import PrivatePolicyModal from 'components/presenters/signup/PrivatepolicyModal';
import { UserInfoActions, UserPermissionActions } from 'store/actionCreators';
import { getQueryStringObject } from 'utils/utils';

const CompanySignupContainer = () => {
    const history = useHistory();
    const modalRef = useRef();
    const queryString = getQueryStringObject();
    const redirectPath = queryString['redirect_path'];

    const [ currentScene, setCurrentScene ] = useState(1);
    const [ initScene, setInitScene ] = useState(false);
    const [ emailToken, setEmailToken ] = useState(null);
    const [ email, setEmail ] = useState('');
    const [ emailCode, setEmailCode ] = useState('');
    const [ validEmail, setValidEmail ] = useState(false);
    const [ emailAuthSent, setEmailAuthSent ] = useState(false);
    const [ emailAuthPassed, setEmailAuthPassed ] = useState(false);
    const [ valid, setValid ] = useState(false);
    const [ password, setPassword ] = useState('');
    const [ confirmPassword, setConfirmPassword ] = useState('');
    const [ emailError, setEmailError ] = useState(null);
    const [ passwordError, setPasswordError ] = useState(null);
    const [ confirmPasswordError, setConfirmPasswordError ] = useState(null);
    const [ nickname, setNickname ] = useState('');
    const [ nicknameError, setNicknameError ] = useState(null);
    const [ name, setName ] = useState('');
    const [ nameError, setNameError ] = useState(null);
    const [ modalVisible, setModalVisible ] = useState(false);
    const [ onSignupComplete, setOnSignupComplete ] = useState(null);
    const [ checkItemsState, setCheckItemsState] = useState([]);
    const [ isSelectAll, setIsSelectAll ] = useState(false);
    const [ checkItems, setCheckItems ] = useState([]);
    const [ termsAndConditionValid, setTermsAndConditionValid ] = useState(false);
    const [ termsAndConditionVisible, setTermsAndConditionVisible ] = useState(false);
    const [ privatePolicyVisible, setPrivatePolicyVisible ] = useState(false);
 
    const [userInfoSetted, setUserInfoSetted] = useState(false);

    //Center Modal State
    const [initCenterModal, setInitCenterModal] = useState(false);
    const [centerModalVisible, setCenterModalVisible] = useState(false);
    const [centerModalDataList, setCenterModalDataList] = useState({});
    const [onModalComplete, setOnModalComplete] = useState(null);
    const [onModalCancel, setOnModalCancel] = useState(null);

    //Loading Modal State
    const [playLoading, setPlayLoading] = useState(false);

    useEffect(()=>{
        if(userInfoSetted === true)
        { 
            if(redirectPath && redirectPath.length > 0)
            {
                history.push(redirectPath);
            }
            else
            {
                history.push('/');     
            }
        }
    },[  userInfoSetted])

    //Init Center Modal State
    useEffect(()=>{
        if(initCenterModal === true)
        {
            setCenterModalVisible(false);
            setCenterModalDataList({})
            setOnModalComplete(null);
            setOnModalCancel(null);
            setInitCenterModal(false);
        }
    }, [initCenterModal])


    const handleChangeEmail = (email) => {
        const isValid = isValidEmail(email); 
        if(isValid || email.length === 0)
        {
            setEmailError(null);
        }
        else
        {
            setEmailError('이메일 형식이 올바르지 않습니다.');
        }
        setEmailAuthPassed(false);
        setEmailAuthSent(false);
        setEmail(email);
    }
    const handleChangeEmailCode = (code) => {
        setEmailCode(code)
    }

    const handleChangePassword = (e) => {
        const passwordValue = e.target.value;
        const isPassword = isValidPassword(passwordValue);
        
        if(isPassword || passwordValue.length === 0)
        {
            setPasswordError(null)
        }
        else 
        {
            setPasswordError('비밀번호는 영문, 숫자, 특수문자 포함 8자 이상으로 설정해 주세요')
        }
        setPassword(passwordValue);
    }

    const checkConfirmPasswordValidate = (value) => {
        return password === value;
    }

    const handleChangeConfirmPassword = (e) => {
        const confirmPasswordValue = e.target.value;
        const isConfirmPassword = checkConfirmPasswordValidate(confirmPasswordValue);
        
        if(isConfirmPassword || confirmPasswordValue.length === 0)
        {
            setConfirmPasswordError(null);
        }
        else
        {
            setConfirmPasswordError('비밀번호가 일치하지 않아요');
        }
        setConfirmPassword(confirmPasswordValue)
    }

    const handleChangeNickname = (e) => {
        const nicknameValue = e.target.value;
        const isNickname = isValidNickname(nicknameValue);
        if(isNickname || nicknameValue.length === 0)
        {
            setNicknameError(null);
        }
        else
        {
            setNicknameError('닉네임은 특수문자 제외 2~10글자로 설정해 주세요')
        }
        setNickname(nicknameValue);
    }
    const handleChangeName = (name) => { 
        const isvalid = isValidName(name); 
        if(isvalid)
        {
            setNameError(null);
            setValid(true);
        }
        else
        {
            setValid(false);
            setNameError('이름은 한글/영어 2~50글자로 설정해 주세요')
        }
        setName(name);
    }

    const isEmailExist = (email) => {
        return server.getRequestData(`auth/signup/validate?email=${email}`, (res) => {
            if(res['success'] === 0)
            {
                if(res['error']['res_data']['err_code'] === 'DATA_ALREADY_EXISTS' && res['error']['res_data']['detail_code'] === "EMAIL_ALREADY_EXIST")
                {
                    setEmailError('이미 존재하는 이메일입니다');
                    setValid(false);
                    setValidEmail(false);
                    return false;
                }
            }
            return true;
        })
    }

    const verifyEmailDomain = () => {
        let form = {
            email: email 
        }
        return server.postRequestData(`auth/email/company`, form, (res) => {
            if(res['success'] !== 1)
            {
                let errData = res['error']['res_data']; 
                if(errData['detail_code'] === "COMPANY_DOMAIN_DOES_NOT_EXIST")
                {
                    setCenterModalVisible(true);
                    setCenterModalDataList({description:"등록된 기업 이메일이 아닙니다."});
                    setOnModalComplete(()=>()=>{
                        setInitCenterModal(true); 
                    })
                }
                else
                {
                    setCenterModalVisible(true);
                    setCenterModalDataList({description:"기업 이메일 인증에 실패하였습니다."});
                    setOnModalComplete(()=>()=>{
                        setInitCenterModal(true); 
                    }) 
                }
                return false;     
            }

            return true;

        })
    }
    const verifyEmailCode = () => {
        let form = {
            email: email,
            code: emailCode
        }
        return server.postRequestData(`auth/email`, form, (res) => {
            if(res['success'] !== 1)
            {
                setCenterModalVisible(true);
                setCenterModalDataList({description:"인증번호가 맞지 않습니다.\n 재발송 하시겠어요?"});
                setOnModalComplete(()=>()=>{
                    setInitCenterModal(true);
                    reqEmailCode();
                })
                setOnModalCancel(()=>()=>{
                    setInitCenterModal(true);
                })
                return false;     
            }
            const jsonData = res.data;
            setEmailToken(jsonData['token']);
            return true;

        })
    }
    const reqEmailCode = async () => {
        try
        {
            if(!isValidEmail(email) )
            {
                setEmailAuthSent(false)
                setEmailAuthPassed(false)
                setCenterModalVisible(true);
                setCenterModalDataList({description:"이메일 형식이 올바르지 않습니다"});
                setOnModalComplete(()=>()=>{
                    setInitCenterModal(true);
                })
                return;
            } 

            setPlayLoading(true);
            let isValidDomain = await verifyEmailDomain();
            if(isValidDomain === false)
            {
                setEmailAuthSent(false)
                setEmailAuthPassed(false)
                setPlayLoading(false);
                return;
            } 


            let form = {
                email: email
            }
            server.postRequestData('auth/email/code',form, (res)=>{
                setPlayLoading(false);

                if(res.success !== 1)
                {
                    let errData = res['error']['res_data']; 
                    if(errData['detail_code'] === "USER_ALREADY_EXIST")
                    {
                        setCenterModalVisible(true);
                        setCenterModalDataList({description:"이미 가입된 유저입니다"});
                        setOnModalComplete(()=>()=>{
                            setInitCenterModal(true);
                        })

                    }
                    else if(errData['detail_code'] === "EMAIL_INVALID_FORMAT")
                    {
                        setCenterModalVisible(true);
                        setCenterModalDataList({description:"이메일 형식이 올바르지 않습니다"});
                        setOnModalComplete(()=>()=>{
                            setInitCenterModal(true);
                        })

                    }
                    else
                    {
                        setCenterModalVisible(true);
                        setCenterModalDataList({description:"인증코드 발송에 실패했습니다.\n 다시 시도해주세요"});
                        setOnModalComplete(()=>()=>{
                            setInitCenterModal(true);
                        })
                    }
                    return;
                }
                setCenterModalVisible(true);
                setCenterModalDataList({description:"인증번호가 발송되었습니다.\n 이메일을 확인해 주세요"});
                setOnModalComplete(()=>()=>{
                    setInitCenterModal(true);
                })
                setEmailAuthSent(true);
            })  
         
        }
        catch(error)
        {
            console.log(error);
            setPlayLoading(false);
        }

        
    }

    const onPrevScene = () => {
        const currentSceneNum = currentScene;
        if(currentSceneNum === 1)
        {
            history.goBack();
        }
        setCurrentScene(currentSceneNum - 1);
    }

    const onNextScene = async () => {
        const currentSceneNum = currentScene;
        if(currentSceneNum === 2)
        {
            const isEmailValidation = await isEmailExist(email);
            const isEmailVerified = await verifyEmailCode();
            if(!isEmailValidation || !isEmailVerified)
            {
               return;
            }
        }
        setCurrentScene(currentSceneNum + 1);
    }

    const isNicknameExist = (nickname) => {
        return server.getRequestData(`auth/signup/validate?nickname=${nickname}`, (res) => {
            if(res['success'] === 0)
            {
                if(res['error']['res_data']['err_code'] === 'DATA_ALREADY_EXISTS' && res['error']['res_data']['detail_code'] === "NICKNAME_ALREADY_EXIST")
                {
                    setNicknameError('이미 존재하는 닉네임입니다');
                    setValid(false);
                    return false;
                }
            }
            return true;
        })
    }

    const onComplete = async () => {
            const isNicknameValidation = await isNicknameExist(nickname);
            if(!isNicknameValidation)
            {
               return;
            }
            setModalVisible(true)
    }

    const sceneController = () => {
        if(currentScene === 1)
        {
            return (<SignupNameScene
                        onChange={handleChangeName}
                        name={name}
                        errorMsg={nameError}
                    />)
        }
        else if(currentScene === 2)
        {
            return <SignupCompanyEmailScene 
                        onEmailChange={handleChangeEmail} 
                        onCodeChange={handleChangeEmailCode} 
                        onAuthReq={reqEmailCode}
                        email={email} 
                        emailCode={emailCode}
                        errorMsg={emailError} 
                   />
        }
        else if(currentScene === 3)
        {
            return <SignupPasswordScene 
                    handleChangePassword={handleChangePassword}
                    password={password}
                    passwordError={passwordError}
                    handleChangeConfirmPassword={handleChangeConfirmPassword}
                    confirmPassword={confirmPassword}
                    confirmPasswordError={confirmPasswordError}
                    setPassword={setPassword}
                    setConfirmPassword={setConfirmPassword}
                   />
        }
        else if(currentScene === 4)
        {
            return <SignupNicknameScene 
                    handleChangeNickname={handleChangeNickname}
                    nickname={nickname}
                    nicknameError={nicknameError}
                    setNickname={setNickname}
                   />
        }
    } 
    const onClickOutSide = (e) => {
        if(modalRef.current && !modalRef.current.contains(e.target))
        {
            setModalVisible(false);
        }
    }

    const onSingleCheck = (e, id) => {
        const { checked } = e.target;
        if(!checked)
        {
            const index = checkItems.indexOf(id)
            const reloadCheckItems = removeItem(checkItems, index);
           
            setCheckItems(reloadCheckItems);
            return;
        }
        setCheckItems([...checkItems, id]);
    }

    const onAllChecked = (e) => {
        const { checked } = e.target;
        
        if(!checked)
        {
            setCheckItems([]);
        }
        else 
        {
            const checkItemList = [];
            for(let i = 0; i < checkItemsState.length; ++i)
            {
                checkItemList.push(checkItemsState[i]['id']);
            }
            setCheckItems(checkItemList);
        }
        setIsSelectAll(checked);
    }

    const isCheckValid = () => {
        if(checkItems.includes(1) && checkItems.includes(2))
        {
            return true;
        }
        return false;      
    }
 

    const onSubmit = async () => {
        const body = {};

        body['email'] = email;
        body['password'] = password;
        body['nickname'] = nickname;
        body['role'] = 'company_member';
        body['email_token'] = emailToken;
        body['name'] = name;

        if(!checkItems.includes(3))
        {
            body['push_notification'] = false;
        }
        else
        {
            body['push_notification'] = true;
        }
        await server.postRequestData(`auth/signup`, body,
        (res) => {
            if(res['success'] === 0)
            {   
                return;
            }
            const jsonData = res['data'];
            const userData = jsonData['user']  
            const permissionData = jsonData['permissions'];
            UserInfoActions.updateUserState({
                name: userData.nickname,
                email: userData.email,
                id: userData.no,
                isLogin: true,
                achievement_goal:userData.achievement_goal,
                profile_img:userData.profile_img,
                exp_point:userData.exp_point
            });
            UserInfoActions.updateRole({
                role: userData['role']
            })  
            if(permissionData)
            {
                UserPermissionActions.updateUserPermission({matching: permissionData['matching']})    
            } 
            setUserInfoSetted(true);
        })
    }

    useEffect(() => {
        setCheckItemsState([
            {
                id: 1,
                description: '[필수] 서비스 이용 약관 동의',
                openModal: () => setTermsAndConditionVisible(true),
            },
            {
                id: 2,
                description: '[필수] 개인정보 수집 및 이용 동의',
                openModal: () => setPrivatePolicyVisible(true),
            },
            {
                id: 3,
                description: '이벤트 및 푸시알림 동의 (선택)',
            }
    ])
    }, [])

    useEffect(() => {
        if(initScene)
        {
            setCurrentScene(1);
            setInitScene(false);
        }
    }, [initScene])

    useEffect(() => { 
        if(email.length !== 0 && !emailError)
        { 
            setValidEmail(true);
        }
        else
        {
            setValidEmail(false); 
        }

        if(email.length === 0)
        {
            setEmailError(null);
        }
    }, [email])

    useEffect(() => { 
        if(validEmail === true && emailAuthSent === true && emailCode.length > 0)
        {
            setValid(true);
        }
        else
        {
            setValid(false);
        } 
    }, [validEmail,emailAuthSent, emailCode])
    

    useEffect(() => {
        if((password.length !== 0 && !passwordError) && (confirmPassword.length !== 0 && !confirmPasswordError))
        {
            setValid(true);
        }
        else
        {
            setValid(false);
        }
        if(password.length === 0)
        {
            setPasswordError(null);
        }
        if(confirmPassword.length === 0)
        {
            setConfirmPasswordError(null);
        }
        if(!checkConfirmPasswordValidate(confirmPassword))
        {
            setValid(false);
            setConfirmPasswordError('비밀번호가 일치하지 않습니다')
        }
    }, [password, confirmPassword])

    useEffect(() => {
        if(nickname.length !== 0 && !nicknameError)
        {
            setValid(true);
        }
        else
        {
            setValid(false);
        }
        if(nickname.length === 0)
        {
            setNicknameError(null);
        }
    }, [nickname])

    useEffect(() => {
        setPlayLoading(false);
        if(currentScene === 1)
        {   
            if(name.length === 0 || !isValidName(name))
            {
                setValid(false); 
            }
            else
            {
                setValid(true);
            }
        }
        else if(currentScene === 2)
        {   
            if(email.length === 0 || !isValidEmail(email) || emailAuthSent !== true || emailCode.length < 6)
            {
                setValid(false); 
            }
            else
            {
                setValid(true);
            }
        }
        else if(currentScene === 3)
        {
            if(password.length === 0 || confirmPassword.length === 0 || password !== confirmPassword)
            {
                setValid(false);
            }
            else
            {
                setValid(true);
            }
        }
        else if(currentScene === 4)
        {
            if(nickname.length === 0)
            {
                setValid(false);
            }
            else
            {
                setValid(true);
            }
        }
    }, [currentScene])
    
    useEffect(() => {
        const isValid = isCheckValid();
        if(isValid)
        {
            setOnSignupComplete(() => () => onSubmit());
        }
        setTermsAndConditionValid(isValid);
        if(isSelectAll && checkItems.length !== 3)
        {
            
            setIsSelectAll(false);
        }
        if(!isSelectAll && checkItems.length === 3)
        {
            setIsSelectAll(true);
        }
    }, [checkItems])

    useEffect(() => {
        if(isSelectAll)
        {
            setTermsAndConditionValid(true);
        }
        else
        {
            const isValid = isCheckValid()
            setTermsAndConditionValid(isValid);
        }
    }, [isSelectAll])

    return( 
        <SignupSection>
            <HeaderSection>
                <TitleHeader onBackBtn={onPrevScene} title={'회원 가입'}/>
            </HeaderSection>
            <BodySection>
            {sceneController() }
            
            </BodySection>
            <ScenePaginationFooter currSceneNum={currentScene} totalSceneNum={4} onNext={onNextScene} valid={valid} onComplete={onComplete}/>
            <CenterModal modalVisible={centerModalVisible} setModalVisible={setCenterModalVisible} dataList={centerModalDataList} onCancel={onModalCancel} onComplete={onModalComplete}/>
            {modalVisible ? 
                <TermsAndConditionCheckModal 
                    onAllChecked={onAllChecked} 
                    isSelectAll={isSelectAll} 
                    onSingleCheck={onSingleCheck} 
                    checkItemsState={checkItemsState} 
                    checkItems={checkItems}
                    termsAndConditionValid={termsAndConditionValid}
                    onSignupComplete={onSignupComplete}
                    onClickOutSide={onClickOutSide}
                    modalRef={modalRef}
                /> 
                : null}
            {
                (playLoading === true)
                ?(
                    <LoadingModal>
                        <LoadingIconWrapper>
                            <img src={loadingImg} alt={'loading in progress'}/>
                        </LoadingIconWrapper>
                    </LoadingModal>
                )
                :(null)
            }
            <TermsAndConditionModal visible={termsAndConditionVisible} onClose={() => setTermsAndConditionVisible(false)}/>
            <PrivatePolicyModal visible={privatePolicyVisible} onClose={() => setPrivatePolicyVisible(false)}/>
        </SignupSection>
    );
}

const SignupSection = styled.div`
    display: flex;  
    flex-direction: column;  
    height: 100vh;
`;

const HeaderSection = styled.div`
    height: calc(100vw * (51 / 375));
    min-height: calc(100vw * (51 / 375));
    flex: 0 1 auto;
`;

const BodySection = styled.div`
    flex: 1 1 auto;
    height: 100%;
    overflow: hidden;
`;
const LoadingModal = styled.div`
    display:flex;
    justify-content: center;
    align-items: center;
    position: absolute;
    top: 0;
    bottom: 0;
    left: 0;
    right: 0;
    margin: auto;
    z-index: 10;
    background: #00000080;
`;
const LoadingIconWrapper = styled.div`
    
    width:calc(100vw*(40/375));
    height:calc(100vw*(40/375));
    
`;
 export default CompanySignupContainer;